<div class="profile-container">
  <div class="">
    <div class="profile-content">
      <div class="personal-details">

        <!-- Header Block -->
        <div class="header-block">
          <div class="header-title">
            <app-breadcrumb></app-breadcrumb>
          </div>
          <div class="add-block">
            <!-- <div class="search">
              <i class="bi bi-search" (click)="getObjectInfoByWildSearch()"></i>
              <form autocomplete="off" style="margin: 0; display: inline-block;">
                <input type="text" (keyup.enter)="getObjectInfoByWildSearch()" [ngModelOptions]="{standalone: true}"
                  [(ngModel)]="searchFilter" placeholder="Search cameras...">
              </form>
            </div> -->

            <div class="search">
              <form autocomplete="off" >
                <input type="text" (keyup.enter)="getObjectInfoByWildSearch()" [ngModelOptions]="{standalone: true}" [(ngModel)]="searchFilter" placeholder="search">
              </form>
              <i class="bi bi-search" (click)="getObjectInfoByWildSearch()"></i>
            </div>
            <div class="filter-icon">
              <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refresh()"></i>
            </div>
          </div>
        </div>

        <!-- Main Layout with Map Block / Video / List -->
        <div class="row map-block">
          <div class="col-md-8 col-lg-8">
            <div class="card-glass">

              <div class="main-layout">

                <!-- Video Section -->
                <div class="video-container" style="flex: 1 1 500px; max-width: 100%;">
                  <div #videoWrapper class="video-wrapper" (dblclick)="toggleFullscreen()"
                    style="position: relative; width: 100%; min-height: 400px; background: #000; border-radius: 12px; overflow: hidden;">
                    <video #video [hidden]="!streaming" autoplay muted playsinline controls class="video-player"></video>
                    <canvas #overlay [hidden]="!streaming" class="video-overlay"></canvas>

                    <div class="no-stream" *ngIf="!streaming">
                      <div class="no-stream-content">
                        <i class="bi bi-camera-video"></i>
                        <h3>No Active Stream</h3>
                        <p>Select an asset from the list to start live monitoring</p>
                      </div>
                    </div>
                  </div>

                  <!-- Controls Bar -->
                  <div class="controls-bar">
                    <button class="btn-modern btn-success-m" (click)="startRecognition()"
                      [disabled]="!streaming || recognizing">
                      <i class="bi bi-play-circle-fill"></i> Start Recognition
                    </button>

                    <button class="btn-modern btn-warning-m" (click)="stopRecognition()" [disabled]="!recognizing">
                      <i class="bi bi-stop-circle-fill"></i> Stop Recognition
                    </button>

                    <button class="btn-modern btn-info-m" (click)="toggleFullscreen()" [disabled]="!streaming">
                      <i class="bi bi-fullscreen"></i> Fullscreen
                    </button>
                  </div>
                </div>

                <!-- Right Sidebar inside the video card -->
                <div class="sidebar-panels">

                  <!-- Detected Instances Thumbnails panel -->
                  <div class="panel-glass">
                    <div class="panel-title">Detected Instances</div>

                    <div *ngIf="latestDetections.length === 0" class="empty-text">
                      No detections currently
                    </div>

                    <div class="panel-scrollable">
                      <div class="thumbnail-grid" *ngIf="latestDetections.length > 0">
                        <div *ngFor="let d of latestDetections" class="thumbnail-card">
                          <img *ngIf="d.crop_b64" [src]="d.crop_b64" class="thumbnail-image" />
                          <div class="thumbnail-info">
                            <div style="display: flex; align-items: center;">
                              <span class="thumbnail-title">{{d.label}}</span>
                              <span *ngIf="d.id" class="thumbnail-id">#{{d.id}}</span>
                            </div>
                            <div class="thumbnail-meta">
                              hits: {{d.hits}} | age: {{d.age}}
                            </div>
                          </div>
                          <button class="btn-small" title="Track Object" (click)="selectThumbnail(d)"><i
                              class="bi bi-crosshair"></i> Track</button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Recognized Faces Panel -->
                  <div class="panel-glass">
                    <div class="panel-title">Recognized Faces</div>

                    <div *ngIf="recognizedFaces.length === 0" class="empty-text">
                      No faces recognized
                    </div>

                    <div class="panel-scrollable">
                      <div *ngIf="recognizedFaces.length > 0">
                        <div *ngFor="let f of recognizedFaces" class="face-card">
                          <div class="face-title">{{ f.name || 'Unknown Reference' }}</div>
                          <div class="face-conf">Confidence: {{ f.confidence | number:'1.2-2' }}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>

          <!-- Component Right Column (Cameras List) -->
          <div class="col-md-4 col-lg-4" style="padding-left: 0;">
            <div class="customerList">
              <div class="list">
                <p (click)="streamCamera(list)" *ngFor="let list of objectInfoList"
                  [title]="'Stream ' + list.givenName"
                  [ngStyle]="{'border-left': selectedCamera === list ? '4px solid #10b981' : '1px solid transparent'}">
                  <span [ngStyle]="{'color': selectedCamera === list ? '#10b981' : '', 'font-weight': selectedCamera === list ? '600' : '500'}">{{list.givenName}}</span>
                  <i class="bi bi-camera-video text-muted" [ngStyle]="{'color': selectedCamera === list ? '#10b981' : ''}"></i>
                </p>
              </div>

              <div class="loader" *ngIf="isLoading"
                style="background: rgba(15, 23, 42, 0.5); border-radius: 12px; height: 100%;">
                <div class="spinner"></div>
                <div style="margin-top: 15px; font-weight: 500;">Loading Cameras...</div>
              </div>

              <div class="loader" *ngIf="!isLoading && (!objectInfoList || objectInfoList.length === 0)"
                style="background: rgba(15, 23, 42, 0.5); border-radius: 12px; height: 100%;">
                <div class="no-data">
                  <img src="assets/no-data-6.png" alt="No data found">
                  <span style="font-weight: 500;">No cameras found</span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>